import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';
import { toISOString } from '../../common/functions';

function _mapCancellation (
  exceptions: CoreTypes.Mixed.Exception[],
  options:   SduiTypes.options
): SduiTypes.substitutionPlan['cancellations'] {
  return exceptions.map(exception => ({
    action:    'cancel',
    lesson_id: exception.sources?.[0].to ? getVertexId(exception.sources[0].to, options) : undefined!,
    comment:   exception.description ?? '',
  }));
}

function _mapLessonChanges (
  exceptions: CoreTypes.Mixed.Exception[],
  options:    SduiTypes.options
): SduiTypes.substitutionPlan['lesson_changes'] {
  return exceptions.map(exception => ({
    action:    exception.reason ?? '',
    lesson_id: exception.sources?.[0].to ? getVertexId(exception.sources[0].to, options) : undefined!,
    comment:   exception.description ?? '',
    classes:   [],
    teachers:  [],
    rooms:     [],
    begins_at: toISOString(exception.start)!,
    ends_at:   toISOString(exception.end)!,
  }));
}

function _mapAdditionals (
  exceptions: CoreTypes.Mixed.Exception[],
  options:    SduiTypes.options
): SduiTypes.substitutionPlan['additionals'] {
  return exceptions.map(exception => ({
    action:    exception.reason ?? '',
    course_id: exception.sources?.[0].to ? getVertexId(exception.sources[0].to, options) : undefined!,
    comment:   exception.description ?? '',
    classes:   [],
    teachers:  [],
    rooms:     [],
    begins_at: toISOString(exception.start)!,
    ends_at:   toISOString(exception.end)!,
  }));
}

export default (
  exceptions: CoreTypes.Mixed.Exception[],
  options:   SduiTypes.options
): SduiTypes.substitutionPlan => {
  const cancellations = _mapCancellation(exceptions.filter(
    exception => exception.action === 'cancel'
  ), options);

  const lesson_changes = _mapLessonChanges(exceptions.filter(
    exception => exception.action && ['substitute', 'reschedule'].includes(exception.action)
  ), options);

  const additionals = _mapAdditionals(exceptions.filter(
    exception => exception.action === 'add'
  ), options);

  return {
    cancellations,
    lesson_changes,
    additionals,
  };
};
